import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
import Swiper from 'swiper/js/swiper.min.js'

var beforeScroH = $(document).scrollTop();
$(document).scroll(function () {
  var scroH = $(document).scrollTop(); //滚动高度
  var viewH = $(window).height(); //可见高度
  $('.section1 .bg').css('transform','translateY('+ scroH / 5 +'px)')

  //浮动二级导航效果
  let fixedNav = $('.section2').offset().top
  let tranH = $('.pc-header .header').outerHeight()-1
  if(scroH > fixedNav){
    if($(window).width()>1024){
      $('.section2 .sec2-fixed').addClass('fixed')
    }else{
      $('.section2 .sec2-fixed').addClass('fixed').css('transform','translateY('+ tranH +'px)')
    }
  }else{
    if($(window).width()>1024){
      $('.section2 .sec2-fixed').removeClass('fixed')
    }else{
      $('.section2 .sec2-fixed').removeClass('fixed').css('transform','translateY(0px)')
    }
  }

  //判断页面是上滚还是下滚
  var delta = scroH - beforeScroH;
  if($(window).width()>1024){
    if(scroH > fixedNav){
      if (delta > 0) {
        $('.section2 .sec2-fixed').css('transform','translateY(0px)')
      }
      if (delta < 0) {
        
        $('.section2 .sec2-fixed').css('transform','translateY('+ tranH +'px)')
      }
    }else{
      $('.section2 .sec2-fixed').css('transform','translateY(0px)')
    }
  }
  beforeScroH = scroH;


  //二级导航高亮对应
  let page1H = $('#page1').offset().top - viewH/4
  let page2H = $('#page2').length > 0 ? $('#page2').offset().top - viewH/4 : page1H
  let page3H = $('#page3').length > 0 ? $('#page3').offset().top - viewH/4 : page2H
  let page4H = $('#page4').length > 0 ? $('#page4').offset().top - viewH/4 : page3H
  let page5H = $('#page5').length > 0 ? $('#page5').offset().top - viewH/4 : page4H
  let page6H = $('#page6').length > 0 ? $('#page6').offset().top - viewH/4 : page5H
  let page7H = $('#page7').length > 0 ? $('#page7').offset().top - viewH/4 : page6H
  let page8H = $('#page8').length > 0 ? $('#page8').offset().top - viewH/4 : page7H
  if(scroH < page2H){
    $('.section2 .scroll-cont a').eq(0).addClass('active').siblings().removeClass('active')
  }else if(scroH > page2H && scroH < page3H){
    $('.section2 .scroll-cont a').eq(1).addClass('active').siblings().removeClass('active')
  }else if(scroH > page3H && scroH < page4H){
    $('.section2 .scroll-cont a').eq(2).addClass('active').siblings().removeClass('active')
  }else if(scroH > page4H && scroH < page5H){
    $('.section2 .scroll-cont a').eq(3).addClass('active').siblings().removeClass('active')
  }else if(scroH > page5H && scroH < page6H){
    $('.section2 .scroll-cont a').eq(4).addClass('active').siblings().removeClass('active')
  }else if(scroH > page6H && scroH < page7H){
    $('.section2 .scroll-cont a').eq(5).addClass('active').siblings().removeClass('active')
  }else if(scroH > page7H && scroH < page8H){
    $('.section2 .scroll-cont a').eq(6).addClass('active').siblings().removeClass('active')
  }else if(scroH > page8H){
    $('.section2 .scroll-cont a').eq(7).addClass('active').siblings().removeClass('active')
  }
});

$(document).ready(function(){
  $('.section2 .scroll-cont a').eq(0).addClass('active');
})

var swiper4 = new Swiper(".section4 .right-swiper .mySwiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  on: {
    init: function(swiper){
      $('.section4 .left-tab div').eq(this.activeIndex).addClass('active')
    },
    slideChangeTransitionStart: function(){
      $('.section4 .left-tab div').eq(this.activeIndex).addClass('active').siblings().removeClass('active')
    },
  },
});

$('.section4 .left-tab div').on('click',function(){
  let index = $(this).index()
  swiper4.slideTo(index)
})

var swiper5 = new Swiper(".section5 .cont .mySwiper", {
  speed: 600,
  effect: "coverflow",
  centeredSlides: true,
  slidesPerView: 1.2,
  initialSlide: 1,
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 700,
    modifier: 1,
    slideShadows: false,
  },
  pagination: {
    el: ".section5 .cont .swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: '.section5 .cont .swiper-button-next',
    prevEl: '.section5 .cont .swiper-button-prev',
  },
});

var swiper7 = new Swiper(".section7 .sec7-swiper .mySwiper", {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 10,
  pagination: {
    el: ".section7 .sec7-swiper .swiper-pagination",
    clickable: true
  },
  breakpoints: {
    1025: {  //当屏幕宽度小于等于768
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 40,
    },
    640: {  //当屏幕宽度小于等于320
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 20,
    }
  } 
});

